import {AbstractItem} from "./abstract-task";
import {FlatpickrFn} from "flatpickr/dist/types/instance";

export class AllTask extends AbstractItem {
  inner: HTMLElement;
  openElement: HTMLElement;
  priorityInputsElements: NodeListOf<HTMLInputElement>;
  priorityHiddenInputsElements: NodeListOf<HTMLInputElement>;
  priorityColorsElements: NodeListOf<HTMLElement>;

  constructor(item: HTMLElement, flatpickr: FlatpickrFn, type: string) {
    super(item, flatpickr, type);

    this.inner = this.item.querySelector(`.js-task-inner-${this.id}`)!;
    this.openElement = this.inner.querySelector(`.js-deadline-open`)!;
    this.priorityInputsElements = this.inner.querySelectorAll(`.js-priority-input`);
    this.priorityHiddenInputsElements = this.inner.querySelectorAll(`.js-priority-h-input`);
    this.priorityColorsElements = this.inner.querySelectorAll(`.js-priority-color`);
  }

  setDeadlineStatusClass(status: string) {
    if (status === `burn`) {
      this.openElement.classList.remove(`task__day--current`);
      this.openElement.classList.add(`task__day--burn`);
    } else {
      this.openElement.classList.remove(`task__day--burn`);
      this.openElement.classList.add(`task__day--current`);
    }
  }
}
